import { mmFetchWithResponse } from 'api/mmFetchWithResponse';

const COMPANY_SOURCES_PATH = 'api/inventory/v1/company-sources';

const companySourcesApi = {
    /**
     * @param {Object} [params]
     * @param {boolean} [params.procurement=false]
     * @param {AbortSignal} [params.signal]
     */
    getCompanySources: async ({ procurement = false, signal } = {}) => {
        const url = procurement ? `${COMPANY_SOURCES_PATH}?procurement=true` : COMPANY_SOURCES_PATH;
        return mmFetchWithResponse(url, { signal });
    },
};

export { companySourcesApi };
